// extracted by mini-css-extract-plugin
export default {"wrapper":"JwtSso_wrapper__63KfM","logo":"JwtSso_logo__WjzV-","message":"JwtSso_message__51UbF","error":"JwtSso_error__Kq+Lf","pulse":"JwtSso_pulse__hovNU"};